import { DeviceConfig } from '@types';

/**
 * Normalizes API `config` into a usable value. Accepts JSON strings or values
 * already parsed by the backend (object / array); otherwise GET would replace
 * config with `{}` and drop fields such as `_exposureEvents`.
 */
export const parseConfiguration = (
  configInput: unknown
): DeviceConfig | null => {
  if (configInput == null) return null;
  if (configInput === '') return null;

  if (Array.isArray(configInput)) {
    return [...configInput] as DeviceConfig;
  }

  if (typeof configInput === 'object') {
    return { ...(configInput as Record<string, unknown>) } as DeviceConfig;
  }

  if (typeof configInput !== 'string') return null;

  try {
    const parsed = JSON.parse(configInput);

    if (Array.isArray(parsed)) {
      return (parsed || {}) as DeviceConfig;
    }

    return parsed as DeviceConfig;
  } catch {
    return null;
  }
};
